import React, {  useState } from "react";
import { useNavigate } from "react-router-dom";

import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";

function UnappliedPayments({ unappliedpayments }) {
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");
  let navigate = useNavigate();

  const handleView = (id) => {
    navigate("/receipts/viewreceipts", { state: id });
  };

  return (
    <>
        <div className="">
          <div className="header pb-0">
            <div className="row"></div>
          </div>
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("RECEIPT NUMBER")}
                    </th>
                    <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                      {t("CONTRACT NUMBER")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("CUSTOMER NAME")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("AMOUNT UNAPPLIED")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("RECEIPT DATE")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {unappliedpayments.map((key) => (
                    <tr>
                      <td className="text-left">
                        {/* <div className="">
                        <div className="">
                          <span className="text-xs font-weight-bold"> */}
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("RECEIPT NUMBER")}{" "}
                          </div>
                          <div>
                            <span
                              // href="javascript:void(0);"
                              onClick={() =>permissionss && permissionsArray.includes('view_receipts')===true ?  handleView(key.id) :""}
                              className="hyperlink"
                            >
                              {key.receipt_number}
                            </span>
                          </div>
                        </>
                        {/* </span>
                        </div>
                      </div> */}
                      </td>
                      <td className="align-middle text-left">
                        {/* <div className="avatar-group mt-2 text-left"> */}
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("CONTRACT NUMBER")}{" "}
                          </div>
                          <div>
                            {key.contract_id
                              ? key.contract_id.contract_number
                              : "None"}
                          </div>
                        </>
                        {/* </div>   */}
                      </td>
                      <td className="align-middle text-left ">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("CUSTOMER NAME")}{" "}
                          </div>
                          <div>
                            {key.customer_id
                              ? key.customer_id.customer_name
                              : "None"}
                          </div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("AMOUNT UNAPPLIED")}{" "}
                          </div>
                          <div>
                            {Helper.Amount(
                              key.receipt_amount - key.applied_amount
                            )}
                          </div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("RECEIPT DATE")}{" "}
                          </div>
                          <div>{Helper.DateNormal(key.receipt_date)}</div>
                        </>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </>
  );
}

export default UnappliedPayments;
